import { useState } from "react";
import api, { formatError } from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "../ui/dialog";
import { Unlock } from "lucide-react";

export const UnlockMonthDialog = ({
  open, onClose, employeeId, year, month, onUnlocked,
  endpoint = "/payroll/attendance/unlock",
  title = "Unlock Finalised Month",
  description = "This month is locked for salary. Enter the payroll unlock password to change its state.",
  successMsg = "Month unlocked — attendance can be edited again",
  testid = "attendance-unlock",
}) => {
  const [pwd, setPwd] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    if (!pwd) { toast.error("Enter the password"); return; }
    setBusy(true);
    try {
      await api.post(endpoint, { employee_id: employeeId, year, month, password: pwd });
      toast.success(successMsg);
      setPwd(""); onUnlocked?.(); onClose();
    } catch (e) { toast.error(formatError(e.response?.data?.detail || e.message)); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v && !busy) { setPwd(""); onClose(); } }}>
      <DialogContent className="max-w-sm" data-testid={`${testid}-dialog`}>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Unlock className="w-4 h-4" /> {title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <div className="space-y-1.5">
          <Label>Password</Label>
          <Input type="password" value={pwd} onChange={(e) => setPwd(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && submit()} autoFocus data-testid={`${testid}-password`} />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={busy}>Cancel</Button>
          <Button onClick={submit} disabled={busy} className="bg-rose-600 hover:bg-rose-700 text-white" data-testid={`${testid}-submit`}>
            {busy ? "Unlocking…" : "Unlock"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
